<template>
  <div class="command-target">
    <v-radio-group
      :value="mode"
      row
      dense
      hide-details
      class="mt-0 pt-0"
      @change="$emit('update:mode', $event)"
    >
      <v-radio
        label="Selected devices"
        value="devices"
      />
      <v-radio
        label="Device group"
        value="group"
      />
    </v-radio-group>

    <div v-if="mode === 'devices'" class="command-target__hint">
      {{ deviceCount }} device{{ deviceCount === 1 ? '' : 's' }} selected
    </div>

    <v-select
      v-else
      :value="groupId"
      :items="groups"
      item-text="name"
      item-value="id"
      :loading="loading"
      label="Device group *"
      :error-messages="error"
      hide-details="auto"
      dense
      @change="$emit('update:groupId', $event)"
    >
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-list-item-subtitle>
            {{ groupDeviceCount(item) }} device{{ groupDeviceCount(item) === 1 ? '' : 's' }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-select>

    <v-alert
      v-if="mode === 'group' && selectedGroupCompanyCount > 1"
      dense
      text
      type="warning"
      class="mt-2 mb-0 command-target__warning"
    >
      This group spans {{ selectedGroupCompanyCount }} companies. The app list below
      is loaded from the current company only, so an app it offers may not exist on
      every device in the group.
    </v-alert>
  </div>
</template>

<script>
  export default {
    name: 'CommandTargetSelector',

    props: {
      mode: {
        type: String,
        default: 'devices',
      },
      groupId: {
        type: [Number, String],
        default: null,
      },
      groups: {
        type: Array,
        default: () => [],
      },
      deviceCount: {
        type: Number,
        default: 0,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      error: {
        type: String,
        default: '',
      },
    },

    computed: {
      selectedGroup () {
        return this.groups.find(group => group.id === this.groupId) || null
      },

      // App lists are per company, so a group spanning several is worth calling out.
      selectedGroupCompanyCount () {
        const devices = (this.selectedGroup && this.selectedGroup.effectiveDevices) || []
        return new Set(devices.map(device => device.companyId).filter(Boolean)).size
      },
    },

    methods: {
      groupDeviceCount (group) {
        return group && group.effectiveDevices ? group.effectiveDevices.length : 0
      },
    },
  }
</script>

<style scoped>
.command-target {
  margin-bottom: 8px;
}

.command-target__warning {
  font-size: 0.8rem;
}

.command-target__hint {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
}
</style>
